<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | PT Bootloader
      .pull-right
        button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
          span.glyphicon.glyphicon-plus
          span  New
    .col-md-12.function_bar(style="display:flex; justify-content: space-between; align-items: center;")
      .form-group
        label.control_label
          | Search:
        tooltip(effect="scale" placement="bottom" content="Search by version, feature or bug fix")
          input.form-control(v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search..." style="display: inline-block; width: auto; vertical-align: middle;")
      .form-group
        label.control_label
          | Category:
        v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
      //- .form-group
      //-   label.control_label
      //-     | Custom:
      //-   v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
      .form-group
        label.control_label
          | Layer:
        v-select(v-bind:value.sync='logFilter.layer.value' v-bind:options='logFilter.layer.opts')
      .form-group
        label.control_label
          | Flash:
        v-select(v-bind:value.sync='logFilter.flashType.value' v-bind:options='logFilter.flashType.opts')
      .form-group(v-if="user.role === 'admin' || isIntrising")
        label.control_label
          | Status:
        v-select(v-bind:value.sync='logFilter.status.value' v-bind:options='logFilter.status.opts')
    spinner(v-ref:spinner size="md" show="true" text="Loading...")
    div(v-if="btLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='searchFilteredTotalLog'
        v-bind:expand-all.sync='expandAll'
        v-bind:show-toggle-expansion-btn='true'
      )
      .col-md-12
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, p) in searchFilteredTotalLog | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media(style="overflow: visible;")
                .media-left
                  .media-object.device_icon(v-bind:class="p.category")
                    img(v-bind:src="getIconSrc(p.category)")
                .media-body(style="overflow: visible;")
                  .media-top
                    span.media-top__info
                      .version-row
                        span.version
                          span(style="margin-right: 4px" v-html='highlightMatches(p.version, searchQuery)')
                          span.glyphicon.glyphicon-link(class="copy-icon" @click="copyToClipboard(p.version)" style="font-size: medium;")
                        span.model.type_tag.base_black.base_grey_bg {{getCustomForUI(p.custom)}}
                        span.model.type_tag.base_black.base_white_bg(v-if="p.series") Series {{ p.series }}
                        span.model.type_tag.base_black.base_white_bg(v-if="p.layer != null") Layer {{ p.layer }}
                        span.model.type_tag.base_black.base_white_bg(v-if="p.flashType") {{ p.flashType.toUpperCase() }}
                        span.model.type_tag.base_black.base_white_bg(v-if="p.isReadOnly && user.role === 'admin'") ReadOnly
                      span.time
                        span.glyphicon.glyphicon-time
                        span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ p.createdAt | fromNow }}
                        span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ p.updatedAt | fromNow }}
                    .action_buttons
                      .btn-group
                        button.btn.btn-sm.btn-default(@click="handleShowModal('update', p['.key'], $index)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-sm.btn-default(@click="handleShowDeleteConfirm(p['.key'])" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        a.btn.btn-sm.btn-default(v-if="p.status === 'release' || user.role === 'admin' || isIntrising" v-on:click='handleDownload(p.url)' v-bind:disabled="p.url === ''")
                          span.glyphicon.glyphicon-cloud-download
                          span  PT Bootloader
                  .media-middle
                    line-table(title='MD5' v-bind:content='p.md5' v-if='p.md5 != null && p.md5.length !== 0')
                    line-table(
                      title='Feature'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && p.feature && p.feature.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(p.feature, searchQuery, false)'
                      v-if='p.feature && p.feature.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
                    line-table(
                      title='Bug Fixed'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && p.bugFixed && p.bugFixed.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(p.bugFixed, searchQuery, false)'
                      v-if='p.bugFixed && p.bugFixed.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
            td.badge_group
              .customized__badge(v-bind:class="p.status")
                span {{p.status}}
      .col-md-12(v-if="searchFilteredTotalLog.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isUpdatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isReleasedAt' readonly v-if="user.role !== 'admin'")
            datepicker(v-bind:value.sync="isReleasedAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Category:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='category' v-bind:value.sync='selectedCategory' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Custom:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='customOpts' v-bind:value.sync='selectedCustom' v-bind:disabled="true")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='version' placeholder='V1.1.5' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="selectedCategory === 'wrouter'")
          .col-md-3.form_label.clearfix
            label.control_label
              | Series:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='series' placeholder='3002 (Optional)' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="['router', 'routerx'].includes(selectedCategory)")
          .col-md-3.form_label.clearfix
            label.control_label
              | Layer:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options="layerOpts" v-bind:value.sync='layer' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Flash Type:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options="flashTypeOpts" v-bind:value.sync='flashType' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | PT Bootloader
              |
              span.glyphicon.glyphicon-cloud-download
              | :
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='url' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | MD5:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='md5' placeholder='' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='status' v-bind:value.sync='selectedStatus' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Feature:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='feature' placeholder='(Optional) [Feature] Support new hardware revision.' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Bug Fixed:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='bugFixed' placeholder='(Optional) [BugFixed] Fix boot failure on cold start.' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin'")
          .col-md-3.form_label.clearfix
            label.control_label(style="padding-top:4px;") Is Read Only:
          .col-md-9.no_pad.clearfix
            checkbox(:checked.sync="isReadOnlyStr" value="true")
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .modal-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
  alert(v-bind:show.sync="showAlert" placement="top" duration="5000" type="danger" width="400px" dismissable)
    span(class="icon-info-circled alert-icon-float-left")
    h4 The following fields are required:
      ul
        li(v-if="!selectedCategory") Category
        li(v-if="!selectedCustom") Custom
        li(v-if="!url") PT Bootloader
        li(v-if="!version") Version
        li(v-if="!selectedStatus") Status
        li(v-if="!isReleasedAt") Release Date
        li(v-if="!md5") MD5
        li(v-if="md5 && md5.length !== 32") MD5 must be 32 characters
</template>
<script>
import moment from 'moment'
import { alert, datepicker, modal, select, spinner, checkbox, tooltip } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import { getDb, getFireBase, getCustomForUI, getIconSrc, filterOptions, naturalSorting, resolveDownloadUrl } from '../../index.js'
import searchMixin from '../../mixins/searchMixin.js'
import clipboardMixin from '../../mixins/clipboardMixin.js'
import permissionsMixin from '../../mixins/permissionsMixin.js'
import _ from 'lodash'
const fb = getFireBase()
const SWITCH_CATEGORY = filterOptions.category
const SWITCH_CUSTOM = filterOptions.custom
const LAYER_OPTS = filterOptions.layer
const FLASH_TYPE_OPTS = filterOptions.flashType

export default {
  mixins: [searchMixin, clipboardMixin, permissionsMixin],
  components: {
    alert,
    datepicker,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner,
    checkbox,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  data () {
    return {
      btLoaded: false,
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'createdAt',
        asc: false
      },
      sortMethodOpts: [
        { label: 'Sort by Release Date', value: 'createdAt' },
        { label: 'Sort by Update Time', value: 'updatedAt' },
        { label: 'Sort by Category', value: 'category' },
        { label: 'Sort by Version', value: 'version' }
      ],
      category: [],
      selectedCategory: 'os5',
      selectedCustom: 'lantech_lantech',
      selectedStatus: 'develop',
      version: '',
      series: '',
      layer: 2,
      flashType: 'nand',
      customOpts: [],
      url: '',
      isReadOnlyStr: '',
      md5: '',
      feature: '',
      bugFixed: '',
      showModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      showDeleteConfirm: false,
      showAlert: false,
      status: filterOptions.status.firmware,
      layerOpts: LAYER_OPTS,
      flashTypeOpts: FLASH_TYPE_OPTS,
      logFilter: {
        // custom: { opts: [], value: 'any' },
        category: { opts: [], value: 'any' },
        status: { opts: [{ label: 'Any', value: 'any' }, ...filterOptions.status.firmware], value: 'any' },
        layer: {
          opts: [{ label: 'Any', value: 'any' }, ...LAYER_OPTS],
          value: 'any'
        },
        flashType: {
          opts: [{ label: 'Any', value: 'any' }, ...FLASH_TYPE_OPTS],
          value: 'any'
        }
      },
      isUpdate: false,
      isUpdatedAt: '',
      isReleasedAt: '',
      bootloader: [],
      temporarySearchQuery: '',
      searchQuery: '',
      expandAll: false
    }
  },
  ready () {
    this.$refs.spinner.show()
    let optAny = { label: 'Any', value: 'any' }

    this.category = _.cloneDeep(SWITCH_CATEGORY)
    this.logFilter.category.opts = _.cloneDeep(SWITCH_CATEGORY)

    // Hide AutoPVT for non-intrising users
    if (!this.isIntrising) {
      this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'autopvt')
    }
    // Carrier Switch is not exposed to LT (non-admin, non-Intrising) users.
    if (this.user.role !== 'admin' && !this.isIntrising) {
      this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'carrier_switch')
    }

    this.logFilter.category.opts.unshift(optAny)
    // this.logFilter.custom.opts = _.cloneDeep(SWITCH_CUSTOM)
    // this.logFilter.custom.opts.unshift(optAny)
    this.customOpts = SWITCH_CUSTOM

    this.logFilter.category.value = this.$route.query.category || 'any'
    // this.logFilter.custom.value = this.$route.query.custom || 'any'
    this.logFilter.layer.value = this.$route.query.layer === 'any' ? 'any' : parseInt(this.$route.query.layer) || 'any'
    this.logFilter.status.value = this.$route.query.status || 'any'
    this.logFilter.flashType.value = this.$route.query.flashType || 'any'
    this.temporarySearchQuery = this.$route.query.search || ''
    this.searchQuery = this.$route.query.search || ''

    if (this.user.custom != null) {
      this.getBootloaderData(this.user.custom)
    }
  },
  computed: {
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    totalLog () {
      const { name, asc: isAsc } = this.sortMethod
      if (name === 'version') {
        return naturalSorting(_.filter(this.bootloader, (x) => x.version), 'version', isAsc ? 'asc' : 'desc')
      } else {
        return _.orderBy(this.bootloader, [name], [isAsc ? 'asc' : 'desc'])
      }
    },
    categoryFilteredTotalLog () {
      return this.totalLog.filter(p => {
        return this.logFilter.category.value !== 'any' ? p.category === this.logFilter.category.value : true
      })
    },
    layerFilteredTotalLog () {
      return this.categoryFilteredTotalLog.filter(p => {
        return this.logFilter.layer.value !== 'any' ? p.layer === this.logFilter.layer.value : true
      })
    },
    flashTypeFilteredTotalLog () {
      return this.layerFilteredTotalLog.filter(p => {
        return this.logFilter.flashType.value !== 'any' ? p.flashType === this.logFilter.flashType.value : true
      })
    },
    statusFilteredTotalLog () {
      const canSeeAllStatus = this.user.role === 'admin' || this.isIntrising
      if (canSeeAllStatus) {
        return this.flashTypeFilteredTotalLog.filter(p => {
          return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : typeof (_.find(this.logFilter.status.opts, {value: p.status})) !== 'undefined'
        })
      }
      return this.flashTypeFilteredTotalLog.filter(p => p.status !== 'develop')
    },
    customFilteredTotalLog () {
      // Carrier Switch must not be exposed to LT (non-admin, non-Intrising) users.
      if (this.user.role === 'admin' || this.isIntrising) {
        return this.statusFilteredTotalLog
      }
      return this.statusFilteredTotalLog.filter(p => p.category !== 'carrier_switch')
    },
    searchFilteredTotalLog () {
      if (this.searchQuery.trim() === '') { return this.customFilteredTotalLog }
      return this.customFilteredTotalLog.filter(p => {
        return p.version.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               (p.feature && p.feature.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
               (p.bugFixed && p.bugFixed.toLowerCase().includes(this.searchQuery.toLowerCase()))
      })
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', { type, title, content })
    },
    handleDownload (url) {
      if (!url) return
      window.open(resolveDownloadUrl(url))
    },
    getCustomForUI,
    getIconSrc,
    handleShowModal (which, key, index) {
      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add PT bootloader'
        this.isUpdate = false
        this.okText = 'Add'
        this.selectedCustom = 'lantech_lantech'
        this.selectedCategory = 'os5'
        this.version = ''
        this.series = ''
        this.layer = 2
        this.flashType = 'nand'
        this.url = ''
        this.md5 = ''
        this.feature = ''
        this.bugFixed = ''
        this.isReadOnlyStr = ''
        this.isReleasedAt = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit PT bootloader'
        this.isUpdate = true
        let { updatedAt = '', createdAt = '', bugFixed = '', feature = '', version, layer = 2, flashType = 'nand', url, md5 = '', series = '', custom, category, status, isReadOnly = false } = this.searchFilteredTotalLog[index + this.pageStart]
        this.isUpdatedAt = ''
        this.isUpdatedAt = moment(updatedAt).format('YYYY-MM-DD HH:mm:ss')
        this.isReleasedAt = ''
        this.isReleasedAt = moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
        this.bugFixed = bugFixed
        this.feature = feature
        this.selectedCategory = category
        this.selectedCustom = custom
        this.selectedStatus = status
        this.layer = layer
        this.flashType = flashType
        this.url = url
        this.md5 = md5
        this.series = series
        this.version = version
        this.isReadOnlyStr = isReadOnly ? 'true' : null
        this.okText = 'Update'
        this.modalCb = this.applyUpdate
      }
      this.showModal = true
    },
    handleShowDeleteConfirm (key) {
      this.editingKey = key
      this.showDeleteConfirm = true
    },
    applyUpload () {
      if (!this.selectedCategory || !this.selectedCustom || !this.url || !this.version || !this.selectedStatus || !this.isReleasedAt || !this.md5 || this.md5.length !== 32) {
        this.showAlert = true
        return
      }
      let toPush = {
        // series is appended to make the composite key unique per product line
        customCategoryVersion: `${this.selectedCustom}_${this.selectedCategory}_${this.version}${this.series ? '_' + this.series : ''}`,
        bugFixed: this.bugFixed,
        category: this.selectedCategory,
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: this.selectedCustom,
        feature: this.feature,
        flashType: this.flashType,
        layer: this.layer,
        md5: this.md5,
        series: this.series,
        isReadOnly: this.isReadOnlyStr === 'true',
        status: this.selectedStatus,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version
      }
      getDb().ref('bootloader').push(toPush)
      this.showModal = false
    },
    applyUpdate () {
      if (!this.selectedCategory || !this.selectedCustom || !this.url || !this.version || !this.selectedStatus || !this.isReleasedAt || !this.md5 || this.md5.length !== 32) {
        this.showAlert = true
        return
      }
      const update = {
        // series is appended to make the composite key unique per product line
        customCategoryVersion: `${this.selectedCustom}_${this.selectedCategory}_${this.version}${this.series ? '_' + this.series : ''}`,
        bugFixed: this.bugFixed,
        category: this.selectedCategory,
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: this.selectedCustom,
        feature: this.feature,
        flashType: this.flashType,
        layer: this.layer,
        md5: this.md5,
        series: this.series,
        isReadOnly: this.isReadOnlyStr === 'true',
        status: this.selectedStatus,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version
      }
      if (this.user.role === 'admin') {
        getDb().ref('bootloader').child(this.editingKey).update(update)
      }

      this.showModal = false
    },
    applyDelete () {
      getDb().ref('bootloader').child(this.editingKey).remove()
      this.showDeleteConfirm = false
    },
    getBootloaderData (custom) {
      let query = ['admin', 'vendor'].includes(this.user.role)
        ? getDb().ref('bootloader')
        : getDb().ref('bootloader').orderByChild('custom').startAt(custom).endAt(custom)
      query.off()
      query.on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.btLoaded = true
          this.bootloader = _.transform(sn.val(), (result, value, key) => {
            result.push({
              '.key': key,
              ...value
            })
          }, [])
        },
        () => {
          query.off()
        }
      )
    },
    updateQueryParams () {
      const query = {
        category: this.logFilter.category.value,
        // custom: this.logFilter.custom.value,
        status: this.logFilter.status.value,
        layer: this.logFilter.layer.value,
        flashType: this.logFilter.flashType.value
      }
      if (this.searchQuery) {
        query.search = this.searchQuery
      }
      this.$router.replace({ query })
    },
    buildClipboardUrl (version) {
      return `${window.location.origin}/pt-bootloader?category=any&custom=any&layer=any&search=${version}&status=any`
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function () {
        this.currPage = 1
        this.currPaginationSec = 1
        this.updateQueryParams()
      }
    },
    searchQuery: function () {
      this.updateQueryParams()
    },
    'user.custom' (curr) {
      if (curr != null) {
        this.getBootloaderData(curr)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}
.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
    textarea {
      height: 150px;
    }
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{
    display: flex;
    align-items: flex-start;
    .media-top__info {
      flex: 1 1 auto;
      min-width: 0;
      .version-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .time {
        display: block;
        margin-top: -4px;
        margin-bottom: 4px;
      }
    }
    .action_buttons {
      flex-shrink: 0;
      padding: 4px 0;
    }
  }
  .version{
    display: inline-block;
    padding: 3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right: 5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right: 5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor: pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  padding-right: 0px !important;
  border-right: none;
}
.badge_group{
  position: relative;
  min-width: 65px;
  overflow: hidden;
  border-left: none;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right: -52px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right: -48px;
  }
}
.error{
  border: 2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width: 100%;
    height: 30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.copy-icon {
  cursor: pointer;
  &:hover {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// PTBootloader.vue?42f26865